
import { Box, Typography, Container, Grid, Paper } from "@mui/material";
import { ServerNews } from "../server-news";

export const ServerNewsPage = () => {
    return (
        <Box
            sx={{
                position: "relative",
                overflow: "hidden",
                minHeight: "100vh",
                py: { xs: 4, sm: 6, md: 8 },
                background:
                    "radial-gradient(circle at 15% 10%, rgba(255,72,32,0.10), transparent 30%), radial-gradient(circle at 90% 20%, rgba(210,35,15,0.08), transparent 28%), linear-gradient(180deg, #070707 0%, #0b0909 50%, #040404 100%)",
                fontFamily: "'Poppins', sans-serif",
                color: "#fff",

                "&:before": {
                    content: '""',
                    position: "absolute",
                    inset: 0,
                    backgroundImage:
                        "linear-gradient(rgba(255,255,255,0.018) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.018) 1px, transparent 1px)",
                    backgroundSize: "45px 45px",
                    maskImage:
                        "linear-gradient(to bottom, black, transparent 85%)",
                    pointerEvents: "none",
                },

                "&:after": {
                    content: '""',
                    position: "absolute",
                    top: 0,
                    left: 0,
                    right: 0,
                    height: "2px",
                    background:
                        "linear-gradient(90deg, transparent, #7e1709, #ff5420, #ff9a4d, #ff5420, #7e1709, transparent)",
                    boxShadow:
                        "0 0 25px rgba(255,84,32,0.45)",
                },
            }}
        >
            {/* =========================================================
                AMBIENT FIRE GLOW
            ========================================================== */}
            <Box
                sx={{
                    position: "absolute",
                    top: "-220px",
                    right: "-220px",
                    width: "620px",
                    height: "620px",
                    borderRadius: "50%",
                    background:
                        "radial-gradient(circle, rgba(255,70,25,0.13) 0%, rgba(160,25,8,0.04) 40%, transparent 70%)",
                    filter: "blur(90px)",
                    pointerEvents: "none",
                }}
            />

            <Box
                sx={{
                    position: "absolute",
                    bottom: "-300px",
                    left: "-250px",
                    width: "650px",
                    height: "650px",
                    borderRadius: "50%",
                    background:
                        "radial-gradient(circle, rgba(255,55,20,0.08), transparent 70%)",
                    filter: "blur(110px)",
                    pointerEvents: "none",
                }}
            />

            <Container
                maxWidth="lg"
                sx={{
                    position: "relative",
                    zIndex: 2,
                }}
            >
                {/* =====================================================
                    COMMAND HEADER
                ====================================================== */}
                <Paper
                    elevation={0}
                    sx={{
                        position: "relative",
                        overflow: "hidden",
                        mb: { xs: 4, md: 5 },
                        p: {
                            xs: 3,
                            sm: 4,
                            md: 5,
                        },
                        borderRadius: "18px",
                        background:
                            "linear-gradient(135deg, rgba(20,12,10,0.96), rgba(9,9,9,0.98))",
                        border:
                            "1px solid rgba(255,84,32,0.18)",
                        boxShadow:
                            "0 25px 70px rgba(0,0,0,0.45), inset 0 1px 0 rgba(255,255,255,0.025)",
                    }}
                >
                    {/* LEFT FIRE BAR */}
                    <Box
                        sx={{
                            position: "absolute",
                            top: 0,
                            left: 0,
                            width: "4px",
                            height: "100%",
                            background:
                                "linear-gradient(180deg, #ff9a4d, #ff5420, #7e1709)",
                            boxShadow:
                                "0 0 25px rgba(255,84,32,0.45)",
                        }}
                    />

                    {/* TOP STATUS */}
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            gap: 2,
                            flexWrap: "wrap",
                            mb: 3,
                        }}
                    >
                        <Box
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: 1.2,
                            }}
                        >
                            <Box
                                sx={{
                                    width: 9,
                                    height: 9,
                                    borderRadius: "50%",
                                    background: "#ff5420",
                                    boxShadow:
                                        "0 0 12px rgba(255,84,32,0.9)",
                                }}
                            />

                            <Typography
                                sx={{
                                    fontSize: "10px",
                                    fontWeight: 800,
                                    letterSpacing: "2.5px",
                                    color: "#ff7140",
                                }}
                            >
                                VEX COMMAND CENTER
                            </Typography>
                        </Box>

                        <Typography
                            sx={{
                                fontSize: "10px",
                                fontWeight: 700,
                                letterSpacing: "1.5px",
                                color: "rgba(255,255,255,0.32)",
                            }}
                        >
                            5165 • SERVER TRANSMISSIONS
                        </Typography>
                    </Box>

                    <Typography
                        sx={{
                            fontSize: {
                                xs: "34px",
                                sm: "46px",
                                md: "58px",
                            },
                            fontWeight: 900,
                            lineHeight: 1,
                            letterSpacing: "-1.5px",
                            mb: 2,
                            color: "#fff",
                        }}
                    >
                        The Vex{" "}
                        <Box
                            component="span"
                            sx={{
                                color: "#ff5420",
                                textShadow:
                                    "0 0 28px rgba(255,84,32,0.28)",
                            }}
                        >
                            Dispatch
                        </Box>
                    </Typography>

                    <Typography
                        sx={{
                            maxWidth: "720px",
                            color: "rgba(255,255,255,0.52)",
                            fontSize: {
                                xs: "13px",
                                sm: "14px",
                            },
                            lineHeight: 1.8,
                        }}
                    >
                        Everything happening across the Vex battlefield,
                        collected in one place. Follow server notices,
                        event announcements, maintenance information,
                        gameplay changes, and important community updates.
                    </Typography>

                    {/* =================================================
                        SERVER TAGS
                    ================================================= */}
                    <Grid
                        container
                        spacing={1.2}
                        sx={{
                            mt: 3,
                        }}
                    >
                        {[
                            "5165 CLASSIC",
                            "LEVEL 130",
                            "1ST REBORN",
                            "CLASSIC PVP",
                        ].map((item) => (
                            <Grid item key={item}>
                                <Box
                                    sx={{
                                        px: 1.5,
                                        py: 0.75,
                                        borderRadius: "6px",
                                        background:
                                            "rgba(255,84,32,0.055)",
                                        border:
                                            "1px solid rgba(255,84,32,0.14)",
                                        color:
                                            "rgba(255,160,120,0.8)",
                                        fontSize: "9px",
                                        fontWeight: 800,
                                        letterSpacing: "1.2px",
                                    }}
                                >
                                    {item}
                                </Box>
                            </Grid>
                        ))}
                    </Grid>
                </Paper>

                {/* =====================================================
                    NEWS CATEGORY STRIP
                ====================================================== */}
                <Grid
                    container
                    spacing={1.5}
                    sx={{
                        mb: { xs: 4, md: 5 },
                    }}
                >
                    {[
                        {
                            icon: "🔥",
                            title: "SERVER",
                            text: "Important notices",
                        },
                        {
                            icon: "⚔",
                            title: "BATTLE",
                            text: "Events & PvP",
                        },
                        {
                            icon: "⚙",
                            title: "UPDATES",
                            text: "Changes & fixes",
                        },
                        {
                            icon: "◆",
                            title: "COMMUNITY",
                            text: "Vex announcements",
                        },
                    ].map((item) => (
                        <Grid item xs={6} sm={3} key={item.title}>
                            <Paper
                                elevation={0}
                                sx={{
                                    height: "100%",
                                    p: 2,
                                    borderRadius: "12px",
                                    background:
                                        "linear-gradient(145deg, rgba(19,19,19,0.95), rgba(11,11,11,0.95))",
                                    border:
                                        "1px solid rgba(255,255,255,0.055)",
                                    transition:
                                        "all .25s ease",

                                    "&:hover": {
                                        transform:
                                            "translateY(-3px)",
                                        borderColor:
                                            "rgba(255,84,32,0.25)",
                                        boxShadow:
                                            "0 12px 35px rgba(0,0,0,0.3)",
                                    },
                                }}
                            >
                                <Typography
                                    sx={{
                                        fontSize: "18px",
                                        mb: 1,
                                    }}
                                >
                                    {item.icon}
                                </Typography>

                                <Typography
                                    sx={{
                                        color: "#fff",
                                        fontSize: "10px",
                                        fontWeight: 900,
                                        letterSpacing: "1.5px",
                                        mb: 0.5,
                                    }}
                                >
                                    {item.title}
                                </Typography>

                                <Typography
                                    sx={{
                                        color:
                                            "rgba(255,255,255,0.35)",
                                        fontSize: "10px",
                                    }}
                                >
                                    {item.text}
                                </Typography>
                            </Paper>
                        </Grid>
                    ))}
                </Grid>

                {/* =====================================================
                    LIVE FEED HEADER
                ====================================================== */}
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        gap: 2,
                        mb: 2.5,
                        px: { xs: 0.5, md: 1 },
                    }}
                >
                    <Box>
                        <Typography
                            sx={{
                                color: "#ff7135",
                                fontSize: "10px",
                                fontWeight: 800,
                                letterSpacing: "2px",
                                mb: 0.6,
                            }}
                        >
                            LATEST TRANSMISSIONS
                        </Typography>

                        <Typography
                            sx={{
                                color: "#fff",
                                fontWeight: 800,
                                fontSize: {
                                    xs: "21px",
                                    md: "25px",
                                },
                            }}
                        >
                            Vex Server Feed
                        </Typography>
                    </Box>

                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 1,
                            px: 1.5,
                            py: 0.8,
                            borderRadius: "20px",
                            border:
                                "1px solid rgba(255,84,32,0.15)",
                            background:
                                "rgba(255,84,32,0.04)",
                        }}
                    >
                        <Box
                            sx={{
                                width: 7,
                                height: 7,
                                borderRadius: "50%",
                                background: "#ff5420",
                                boxShadow:
                                    "0 0 10px rgba(255,84,32,0.8)",
                            }}
                        />

                        <Typography
                            sx={{
                                color:
                                    "rgba(255,255,255,0.45)",
                                fontSize: "9px",
                                fontWeight: 800,
                                letterSpacing: "1px",
                            }}
                        >
                            LIVE FEED
                        </Typography>
                    </Box>
                </Box>

                {/* =====================================================
                    ACTUAL SERVER NEWS
                ====================================================== */}
                <Box
                    sx={{
                        position: "relative",
                        zIndex: 2,

                        "& > *": {
                            position: "relative",
                        },

                        /* Make the existing news component blend
                           into the Vex page without changing its logic. */
                        "& .MuiCard-root": {
                            background:
                                "linear-gradient(145deg, rgba(18,18,18,0.98), rgba(9,9,9,0.98))",
                            borderColor:
                                "rgba(255,84,32,0.13)",
                        },

                        "& .MuiPaper-root": {
                            borderColor:
                                "rgba(255,84,32,0.13)",
                        },
                    }}
                >
                    <ServerNews />
                </Box>

                {/* =====================================================
                    VEX INFO PANEL
                ====================================================== */}
                <Paper
                    elevation={0}
                    sx={{
                        mt: { xs: 5, md: 7 },
                        p: {
                            xs: 3,
                            md: 4,
                        },
                        borderRadius: "16px",
                        background:
                            "linear-gradient(135deg, rgba(18,12,10,0.95), rgba(8,8,8,0.98))",
                        border:
                            "1px solid rgba(255,84,32,0.12)",
                        position: "relative",
                        overflow: "hidden",
                    }}
                >
                    <Box
                        sx={{
                            position: "absolute",
                            top: 0,
                            left: 0,
                            width: "100%",
                            height: "2px",
                            background:
                                "linear-gradient(90deg, transparent, #ff5420, transparent)",
                        }}
                    />

                    <Grid
                        container
                        spacing={3}
                        alignItems="center"
                    >
                        <Grid item xs={12} md={7}>
                            <Typography
                                sx={{
                                    color: "#ff7135",
                                    fontSize: "10px",
                                    fontWeight: 800,
                                    letterSpacing: "2px",
                                    mb: 1,
                                }}
                            >
                                KEEP YOUR EYES OPEN
                            </Typography>

                            <Typography
                                sx={{
                                    color: "#fff",
                                    fontSize: {
                                        xs: "22px",
                                        md: "28px",
                                    },
                                    fontWeight: 900,
                                    lineHeight: 1.2,
                                    mb: 1.2,
                                }}
                            >
                                The next battle may already be loading.
                            </Typography>

                            <Typography
                                sx={{
                                    color:
                                        "rgba(255,255,255,0.42)",
                                    fontSize: "12px",
                                    lineHeight: 1.8,
                                }}
                            >
                                Check the Vex news feed regularly for
                                event announcements, maintenance notices,
                                server changes, and important information
                                before entering the battlefield.
                            </Typography>
                        </Grid>

                        <Grid item xs={12} md={5}>
                            <Box
                                sx={{
                                    display: "grid",
                                    gridTemplateColumns:
                                        "repeat(2, 1fr)",
                                    gap: 1,
                                }}
                            >
                                {[
                                    ["5165", "CLASSIC CORE"],
                                    ["130", "MAX LEVEL"],
                                    ["+9", "MAX PLUS"],
                                    ["-5", "BLESS"],
                                ].map(([value, label]) => (
                                    <Box
                                        key={label}
                                        sx={{
                                            p: 1.8,
                                            textAlign: "center",
                                            borderRadius: "9px",
                                            background:
                                                "rgba(255,255,255,0.025)",
                                            border:
                                                "1px solid rgba(255,255,255,0.05)",
                                        }}
                                    >
                                        <Typography
                                            sx={{
                                                color: "#ff7135",
                                                fontWeight: 900,
                                                fontSize: "18px",
                                            }}
                                        >
                                            {value}
                                        </Typography>

                                        <Typography
                                            sx={{
                                                color:
                                                    "rgba(255,255,255,0.32)",
                                                fontSize: "8px",
                                                fontWeight: 800,
                                                letterSpacing: "1px",
                                            }}
                                        >
                                            {label}
                                        </Typography>
                                    </Box>
                                ))}
                            </Box>
                        </Grid>
                    </Grid>
                </Paper>

                {/* =====================================================
                    BOTTOM BRAND
                ====================================================== */}
                <Box
                    sx={{
                        mt: { xs: 5, md: 7 },
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: 2,
                    }}
                >
                    <Box
                        sx={{
                            flex: 1,
                            maxWidth: "180px",
                            height: "1px",
                            background:
                                "linear-gradient(90deg, transparent, rgba(255,84,32,0.25))",
                        }}
                    />

                    <Typography
                        sx={{
                            color: "#3f3f3f",
                            fontSize: "9px",
                            fontWeight: 800,
                            letterSpacing: "2px",
                        }}
                    >
                        VEX CONQUER • CLASSIC 5165
                    </Typography>

                    <Box
                        sx={{
                            flex: 1,
                            maxWidth: "180px",
                            height: "1px",
                            background:
                                "linear-gradient(90deg, rgba(255,84,32,0.25), transparent)",
                        }}
                    />
                </Box>
            </Container>
        </Box>
    );
};

